import config from '../../../config.json'
import { MOVIE } from '../../../constants/itemTypes'
import ListItemMovieContainer from '../../DragAndDropItems/cont/ListItemMovieContainer'

const EditPrintTypesDragSwitch = ({
    itemId,
    itemType,
    itemData,
    basicUrl,
    isSelected=false,
    basePreviewUrl,
    canEdit,
    canDelete=false,
    deleteItem=false
}) => {
    const basicPathNameEdit = `${basicUrl}/${itemType}/`

    return (
        !itemData || MOVIE !== itemType ? (
            ''
        ) : (
            <ListItemMovieContainer
                itemType={itemType}
                basePreviewUrl={basePreviewUrl}
                itemData={itemData}
                isSelected={isSelected}
                pathnameEdit={canEdit ? basicPathNameEdit + itemData.id : false}
                onDelete={canDelete && deleteItem ? () => deleteItem(itemId, itemType) : false}
            />
        )
    )
}

export default EditPrintTypesDragSwitch

